import { Download } from "lucide-react"
import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { showAlert } from "store/reducers/alertReducer"
import update_assets_status_sample from "assets/file/update_assets_status_sample.xlsx"
import { uploadAssetsStatusFile } from "store/actions/cardsAction"

const UpdateAssetsStatusByFileModal = ({ isOpen, toggle, trigger }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const fileInputRef = useRef(null)

  const [file, setFile] = useState(null)
  const [isApiCalled, setIsApiCalled] = useState(false)

  const handleSubmit = () => {
    setIsApiCalled(false)
    if (!file) {
      dispatch(showAlert({ text: t("Upload file"), type: "error" }))
      return
    }
    let data = new FormData()

    data.append("assets_file", file)

    setIsApiCalled(true)

    dispatch(uploadAssetsStatusFile(data))
      .then(action => {
        const { statusCode, success, message } = action?.payload || {}
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          trigger()
          setIsApiCalled(false)

          toggle()
        } else {
          setIsApiCalled(false)

          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleFileChange = event => {
    const selectedFile = event.target.files[0]
    setFile(selectedFile)
  }

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{t("Update Assets Status")}</ModalHeader>
      <ModalBody>
        <div className="border rounded p-3">
          <div>
            <div className="form_field">
              <input
                type="file"
                accept=".xlsx"
                className="w-100"
                style={{ padding: 5 }}
                onChange={handleFileChange}
                ref={fileInputRef}
              />
              <div className="g_start my-3">
                <Download size={18} className="text-primary" />
                <a
                  href={update_assets_status_sample}
                  download="update_assets_status_sample.xlsx"
                  className="px-1"
                >
                  {t("Download a demo XLSX file")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex flex-wrap gap-2">
          <button
            type="button"
            className="main_btn disabled-button fit_content px-4"
            onClick={toggle}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="main_btn fit_content px-4"
            onClick={handleSubmit}
            disabled={isApiCalled}
          >
            {t("Upload")}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default UpdateAssetsStatusByFileModal
